import type { Option } from "utils/options";
import type {
  CommonPageResponse,
  CommonResponse,
} from "./commonInterface.interface";

export interface LicenseItem {
  name: string;
  version: string;
  moduleLicense: string;
  moduleUrl: string;
}

export interface GetLicenseListResponse extends CommonPageResponse {
  result: LicenseItem[];
}

export interface GetVersionResponse extends CommonPageResponse {
  result: string;
}

export interface ContactInfoItem {
  sites: {
    id?: string;
    site: string;
  }[];
  emails: {
    id?: string;
    email: string;
    description?: string;
  }[];
  phones: {
    id?: string;
    phone: string;
    description?: string;
  }[];
  customFields: (Option & { id?: string })[];
}

export interface GetContactInfoResponse extends CommonResponse {
  result: ContactInfoResponse;
}
export interface ContactInfoResponse extends ContactInfoItem {
  id?: string;
  cpAccountId?: string;
}

export enum ADMINUNLOCK_MODEL {
  N0A = "N0A",
  N0Z = "N0Z",
  D1E = "D1E",
}
export interface OtpRequest {
  device: string; // VMAX COVA
  model?: ADMINUNLOCK_MODEL;
  macAddress: string;
  expireDate: string;
}

export interface OtpResponse extends CommonResponse {
  result: string;
}

export interface TechSupportSubmit {
  email: string;
  userType: string;
  name: string;
  phone: string;
  address: string;
  description: string;
  firstName?: string;
  lastName?: string;
}

export interface TechSupportDto {
  id: string;
  createdAt: string;
  updatedAt: string;
  level: string;
  accountId: string;
  accountNumber: string;
  category: string;
  status: string;
  email: string;
  userType: string;
  name: string;
  phone: string;
  address: string;
  description: string;
  fileName: string;
  fileUrl: string;
  fileBytes: Blob;
  treatment: string;
}

export interface GetTechSupportListResponse extends CommonPageResponse {
  result: TechSupportDto[];
}
